module.exports = __webpack_public_path__ + "img/inbox.ef1cc6ed.svg";